import ApiUtils from 'shared/ApiUtils';
import { formatAsProperName } from './helpers';
import moment from 'moment';
import * as turf from '@turf/turf';

class DataPreprocessing {

    static ACCESS_TOKEN_APPLICATION = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjoidXBsb2FkZXIiLCJ1c2VyX2lkIjo5OSwiZXhwIjoxOTEwNTM3MDgxfQ.g4YKraV3vYilN3WEyc2eq9nLP1az_CZD1LcDlanR5Tg'

        // translate the functions from backend to here

    static getfile =   () => {
        var propertiesf;
        var subsidiesf;
        var residentf;
        var agenciesf;
        var uploadsf;
        var ownersf;

    
        return this.retrieveData("properties").then(([response, jsonBody]) => {
            propertiesf = jsonBody
            return this.retrieveData("subsidies").then(([response2, jsonBody2]) => {
                subsidiesf = jsonBody2
                return this.retrieveData("residents").then(([response3, jsonBody3]) => {
                    residentf = jsonBody3
                    return this.retrieveData("agencies").then(([response4, jsonBody4]) => {
                        agenciesf = jsonBody4
                        return this.retrieveData("uploads").then(([response5, jsonBody5]) => {
                            uploadsf = jsonBody5
                            return this.retrieveData("owners").then(([response6, jsonBody6]) => {
                                ownersf = jsonBody6

                                var propertiesDict = {};

                                var subsidiesCnt =  this.joinSubsidyandResident(subsidiesf, residentf)
                                var uploadsDict =  this.joinAgenciesandUploads(agenciesf, uploadsf)

                                propertiesf.forEach(function(prop,propIndex){
                                    if (prop["upload_id"] in uploadsDict){
                                        prop["uploads"] = uploadsDict[prop["upload_id"]]
                                    }
                                    if (prop["id"] in subsidiesCnt){
                                        prop["subsidy"] = subsidiesCnt[prop["id"]]
                                    }
                                    else{
                                        prop["subsidy"] = []
                                    }
                                    // add owner name to property
                                    var owner = ownersf.filter(function(item){
                                        return item.id === prop.owner_id
                                    })[0]

                                    if(owner){
                                        prop["owner_name"] = owner.name
                                    }
                                    else{
                                        prop["owner_name"] = null
                                    }
                                   
                                    propertiesDict[prop["id"]] = prop
                                })

                                var output = this.reduce(Object.values(propertiesDict), agenciesf)

                                return Promise.all([Promise.resolve(response6), output]);
                            }) 
                                .catch((err) => {
                                console.log('Error:', err)
                            })
                                
                        }) 
                            .catch((err) => {
                            console.log('Error:', err)
                        })
                    }) 
                        .catch((err) => {
                        console.log('Error:', err)
                    })
                }) 
                    .catch((err) => {
                    console.log('Error:', err)
                })
            }) 
                .catch((err) => {
                console.log('Error:', err)
            })
        }) 
            .catch((err) => {
            console.log('Error:', err)
        })
        
    }

    static reduce = (data, agencyInfo) => {
        // var agenciesDict = {}
      // """
      // join uploads table and agencies
      // """
        // agencyInfo.forEach(function(agent,agentIndex){
        //     agenciesDict[agent["id"]] = agent
        // })

        // console.log(agenciesDict);
      
        // console.log(data);
        var res = []

        var calRisk = this.calRisk;



        const getStewardingAgency = (fundingArray, uploads, agencyInfo) => {

          const agenciesStewardingHOME = [
            'Georgia Department of Community Affairs',
            'City of Atlanta'
          ];

          const strArray = []
          const fundingSource = fundingArray[0] || null
          if (fundingSource.includes('LIHTC')) {
            strArray.push('Georgia Department of Community Affairs');
          };
          if (fundingSource.includes('HomeFlex')) {
            strArray.push('Atlanta Housing');
          };  
          if (fundingSource.includes('HOME')) {
            const upload = uploads[0];
            let agencyName = 'n/a'
            agencyInfo.forEach(obj => obj.uploads.forEach(uploadID => { if (upload === uploadID) agencyName = obj.name}))

            strArray.push(agenciesStewardingHOME.includes(agencyName) ? agencyName : 'n/a');
          };
          if (fundingSource.includes('Section 202') || fundingSource.includes('Section 8')) {
            strArray.push('Housing and Urban Development');
          };
          if (fundingSource.includes('Public Housing') || fundingSource.includes('AH Subsidy')) {
            strArray.push('Atlanta Housing');
          };
          
          if (strArray[0]) {
            if (strArray.length === 1) {
              return strArray[0];
            }
            if (strArray.length >= 2) {
              return strArray.join(', ');
            }
            // if (strArray.length > 2) {
            //   return `${strArray.filter((str, i) => i < strArray.length - 1).join(', ')} & ${strArray[strArray.length -1]}`
            // }
          }

          return 'n/a';               
        };

        //var count = 0
        // console.log(data.filter(function(feature){
        //     return feature.subsidy.length == 0
        // }))
        data.forEach(function(prop,propIndex){
            
            var cnt = 0
            var tempsublist = []
            var temp = {}
            temp["id"]= prop["id"]
            temp["longitude"] = prop["longitude"]
            temp["latitude"] = prop["latitude"]
            temp["address"] = prop["address"]
            temp["totalUnits"] = prop["total_units"]
            temp["ownerName"] = formatAsProperName(prop["owner_name"]) || 'n/a'
            
            if (temp["totalUnits"] == null){
                
                temp["totalUnits"] = 'n/a'
            }
            prop["subsidy"].forEach(function(subunit,subunitIndex){

                // console.log(subunit)
                // console.log(subunit);
                var tempsub = {}
                tempsub["SubStart"] = subunit["start_date"] ? moment(subunit["start_date"]).format('M/D/YYYY') : 'n/a'
                tempsub["SubEnd"] = subunit["end_date"] ? moment(subunit["end_date"]).format('M/D/YYYY') : 'n/a'
                tempsub["Funding"] = []
                if ("funding_sources" in subunit){
                    subunit["funding_sources"].forEach(function(fs,fsIndex){
                        tempsub["Funding"].push(fs["source"])
                    })
                }

                if ( !tempsub["Funding"][0]){
                  tempsub["Funding"] = ['n/a']
                }

               


                
                
                tempsub["RiskUnits"] = calRisk(tempsub["SubEnd"])
                // console.log(calRisk(tempsub["SubEnd"]))
                tempsub["Stewarding"] = getStewardingAgency(tempsub['Funding'],subunit['uploads'], agencyInfo)
                tempsub["UnitsSub"] = subunit["low_income_units"]
                // tempsub["tenantType"] = "n/a"
                if ("resident" in subunit){
                    subunit["resident"] = subunit["resident"]["type"]
                }
                tempsub["tenantType"] = subunit["resident"] || 'n/a'

                tempsub["ami_30"] = subunit["ami_30"]
                tempsub["ami_50"] = subunit["ami_50"]
                tempsub["ami_60"] = subunit["ami_60"]
                tempsub["ami_80"] = subunit["ami_80"]
                tempsub["ami_100"] = subunit["ami_100"]
                tempsub["ami_115"] = subunit["ami_115"]
                tempsub["ami_120"] = subunit["ami_120"]
                tempsub["housingType"] = subunit["development_type"] || 'n/a'
                tempsub["project_name"] = formatAsProperName(subunit["project_name"])
                tempsub["updated_on"] = subunit["updated_on"]
                tempsub["riskOfExp"] = subunit['risk_of_exp'] ? moment(subunit['risk_of_exp']).format('M/D/YYYY') : null
                
                if (subunit["low_income_units"] !== null){
                    if(subunit["low_income_units"] > cnt){
                    // cnt += subunit["low_income_units"]
                        cnt = subunit["low_income_units"]
                    }

                    tempsub["subsidyPercentSub"] = subunit["low_income_units"]/temp["totalUnits"]*100
                }
                else{
                    tempsub["subsidyPercentSub"] = 0
                    tempsub["UnitsSub"] = 0
                }

                tempsublist.push(tempsub)
            })
            
            temp["totalSubsidizedUnits"] = cnt

            

            temp["subsidies"] = tempsublist
            if (temp["totalUnits"] !== 0){
                temp["totalPercentSubsidized"] = temp["totalSubsidizedUnits"]/temp["totalUnits"]*100
            }
            else{
                temp["totalPercentSubsidized"] = 0
            }
            // if (temp["totalPercentSubsidized"] > 100){
            //     count += 1
            // }
            temp['census_tract'] = prop["census_tract"]
            temp['neighborhood_statistical_area'] = prop['neighborhood_statistical_area']
            temp['neighborhood_planning_unit'] = prop['neighborhood_planning_unit']
            temp['tax_allocation_district'] = prop['tax_allocation_district']
            temp['city_council_district'] = prop['city_council_district']
            res.push(temp)
        })
        
        return res
    }

    static calRisk = (datestr) => {
        if (datestr == null){
            return "n/a"
        }
        
        var datedata = datestr.replace('-', ' ').replace('-', ' ').split(' ')
        // console.log(datedata)
        // today = date.today()
        // delta = (date(int(datedata[0]), int(datedata[1]), int(datedata[2])) - today).days

        // Todo: might need to change the order of month day and year
        var currentTime = new Date();
        var dd = String(currentTime.getDate()).padStart(2, '0');
        var mm = String(currentTime.getMonth() + 1).padStart(2, '0'); //January is 0!
        var yyyy = currentTime.getFullYear();
        var today = new Date(mm + '/' + dd + '/' + yyyy);
        
        var dateForRecord = new Date(String(datedata[1])+'/'+ String(datedata[2]) +'/'+ String(datedata[0]));
        var Difference_In_Time =  dateForRecord.getTime() - today.getTime();

        
        var delta = Difference_In_Time / (1000 * 3600 * 24);
        

        if (delta <= 0){
            return "n/a"
        }
        else if (delta <= 6*30){
            return "Expiring within 6 months"
        }
        else if ( delta <= 365){
            return "Expiring within 1 year"
        }
        else if ( delta <= 3*365){
            return "Expiring within 3 years"
        }
        else if ( delta <= 5*365){
            return "Expiring within 5 years"
        }
        else{
            return "n/a"
        }
    }

    static joinSubsidyandResident =  (subsidiesTable, residentsTable) => {
        var subsidiesDict = {}
        // """                                                       
        // join subsidies and residents                              
        // """

        subsidiesTable.forEach(function(subsidy,subsidyIndex){
            subsidiesDict[subsidy["id"]] = subsidy
        });

        // const getSubidyStats = field => {
        //   const obj = {};
        //   subsidiesTable.forEach(item => 
        //     obj[item[field]] ? obj[item[field]] += 1 : obj[item[field]] = 1)
        //   return obj
        // }

        // console.log(getSubidyStats("development_type"));

        const residentTypesExclude = ['', 'Renter', 'Multifamily']


        residentsTable
          .filter(resident => !residentTypesExclude.includes(resident["type"]))
          .forEach(function(resident){
            if (resident["subsidy_id"] in subsidiesDict) subsidiesDict[resident["subsidy_id"]]["resident"] = {...resident};
        })
            
        var subsidiesList = Object.values(subsidiesDict)
        var subsidiesCnt = {}
        subsidiesList.forEach(function(x,xIndex){
            if (x["property_id"] in subsidiesCnt){
                subsidiesCnt[x["property_id"]].push(x)
            }else{
                subsidiesCnt[x["property_id"]] = []
                subsidiesCnt[x["property_id"]].push(x)
            }
            
        })
                    
        return subsidiesCnt
    }

    static joinAgenciesandUploads = (agenciesTable, uploadsTable) => {
        var uploadsDict = {}
        var agenciesDict = {}
        // """
        // join uploads table and agencies
        // """
        agenciesTable.forEach(function(agent,agentIndex){
            agenciesDict[agent["id"]] = agent
        })
        
        uploadsTable.forEach(function(upload,uploadIndex){
            if (upload["agency_id"] in agenciesDict){
                upload["agent"] = agenciesDict[upload["agency_id"]]
            }
            uploadsDict[upload["id"]] = upload
        })
            
        return uploadsDict
    }

    static retrieveData =  (key) => {
        
        if (key === "subsidies"){
            // const url = 'https://houseatl.cloud.rnoc.gatech.edu/rest/'+key+'?select=*,funding_sources(*)?';
            const url = 'https://house-atl-api-dev.herokuapp.com/rest/'+key+'?';
        
            // return ApiUtils.getAuth(url, this.ACCESS_TOKEN_APPLICATION)
            return ApiUtils.callURLNoBody(url, 'get')
                            .then(([response, jsonBody]) => {
                                if (response.status === 200) {
                                    //console.log(response)
                                    return Promise.all([Promise.resolve(response), jsonBody]);

                                } else {
                                    console.log(jsonBody.message)
                                }
                            })
                            .catch((err) => {
                                console.log('Error:', err)
                            })
            
            
        }else{
            // const url = 'https://houseatl.cloud.rnoc.gatech.edu/rest/'+key+'?';
            const url = 'https://house-atl-api-dev.herokuapp.com/rest/'+key+'?';

            // return ApiUtils.getAuth(url, this.ACCESS_TOKEN_APPLICATION)
            return ApiUtils.callURLNoBody(url, 'get')
                            .then(([response, jsonBody]) => {
                                if (response.status === 200) {
                                   // console.log(response)
                                    return Promise.all([Promise.resolve(response), jsonBody]);

                                } else {
                                    console.log(jsonBody.message)
                                }
                            })
                            .catch((err) => {
                                console.log('Error:', err)
                            })
            
        }

    }

    static convertToGeoJSON = (data) => {
        var geores = []

        data.forEach(function(rec,recIndex){
            var georec = {}
            georec["type"] = 'Feature'
            var geocoord = {}
            geocoord["type"] = 'Point'
            var coord = []
            coord.push(rec["longitude"])
            coord.push(rec["latitude"])
            geocoord["coordinates"] = coord
            georec["geometry"] = geocoord
            georec["properties"] = rec
            georec["type"] = "Feature"
            geores.push(georec)
        })

        var mapboxgeojson = {}
        mapboxgeojson["type"] = "FeatureCollection"
        mapboxgeojson["features"] = geores
        return mapboxgeojson
    }

    static convertToGeoJSONForPipelineData = (data) => {
        var geores = []

        data.forEach(function(rec,recIndex){
            var georec = {}
            georec["type"] = 'Feature'
            var geocoord = {}
            geocoord["type"] = 'Point'
            var coord = []
            coord.push(parseFloat(rec["Longitude"]))
            coord.push(parseFloat(rec["Latitude"]))
            geocoord["coordinates"] = coord
            georec["geometry"] = geocoord
            georec["properties"] = rec
            georec["type"] = "Feature"
            geores.push(georec)
        })

        var mapboxgeojson = {}
        mapboxgeojson["type"] = "FeatureCollection"
        mapboxgeojson["features"] = geores
        return mapboxgeojson
    }

    static addHousingSummarytoGeoData = (geoData, HousingData) => {
        // console.log(geoData)
        // console.log(HousingData)

        var riskunits = []
        var subunits = []
        var totalunits = []
        geoData["features"].forEach(function(planegeo,planegeoIndex){
            riskunits.push(0)
            subunits.push(0)
            totalunits.push(0)
        })

        //console.log(totalunits)

        HousingData["features"].forEach(function(prop,propIndex){
            
            geoData["features"].every(function(plane,id){
                if (turf.inside(prop, plane)){
                    let initialSubUnits = 0
                    prop["properties"]["subsidies"].forEach(function(sub,subIndex){
                        if (sub["RiskUnits"] === "Expiring within 6 months"){
                            riskunits[id] = riskunits[id]+ sub["UnitsSub"]
                        }
                        if (sub["UnitsSub"]>initialSubUnits){
                            initialSubUnits = sub["UnitsSub"]
                        }
                        
                        
                    })
                    // if (prop["properties"]["totalUnits"] !== "n/a"){
                        
                        totalunits[id] = totalunits[id] + 1
                    // }
                    subunits[id] = subunits[id] + initialSubUnits

                    return false
                }
                else{
                    return true
                }
            })


        })

        //console.log(totalunits)
        var resutls = geoData

        resutls["features"].forEach(function(planefeature,id){
            planefeature["properties"]["Total_Unit"] = totalunits[id]
            planefeature["properties"]["Sub_Unit"] = subunits[id]
            planefeature["properties"]["Risk_Unit"] = riskunits[id]
        })

        

        return resutls
    }

    static filterDataBeforeFeedIntoDashboard = (HousingData) =>{
        //console.log(HousingData)
        
        var processedData = HousingData

        // console.log(processedData.features.filter(function(feature){
        //     return feature.properties.subsidies.length == 0
        // }))
        
        HousingData.features.forEach(function(feature, featureIndex){
            //Filter data without start and end date (except for public housing)
            processedData.features[featureIndex].properties.subsidies = feature.properties.subsidies.filter(function(subsidy){
                if(subsidy.Funding.includes('Public Housing')){
                    return true
                    
                }else{

                    if(subsidy.SubStart === null && subsidy.SubEnd === null ){
                        //console.log(feature.properties.address)
                        return false
                    }
                    //Filter data with 0 subsidized units
                    if(subsidy.UnitsSub === 0 ){
                        //console.log(feature.properties.address)
                        return false
                    }

                }
                return true
            })

        })

        // console.log(processedData.features.filter(function(feature){
        //     return feature.properties.subsidies.length == 0
        // }))

        //Filter data with 0 subsidized units
        var updatedProperties = processedData.features.filter(function(feature){
            return feature.properties.totalSubsidizedUnits !== 0
        })

        

        // Filter data with 0 subsidies
     
        updatedProperties = updatedProperties.filter(function(feature){
            return feature.properties.subsidies.length !== 0
        })

        processedData = { features: updatedProperties, type: 'FeatureCollection', }
        
        // console.log(processedData.features.filter(function(feature){
        //     return feature.properties.subsidies.length == 0
        // }))

        return processedData
    }
}

export default DataPreprocessing